import { record } from 'rrweb';

const API = process.env.REACT_APP_BACKEND_URL;
export const wsUrl = (sid, token) => `${API.replace(/^http/, 'ws')}/api/cobrowse/ws/${sid}?token=${encodeURIComponent(token)}`;
export const SPEICHER = 'cobrowse_sitzung';
export const ZUSTIMMUNG = 'Ich bin einverstanden, dass eine Mitarbeiterin oder ein Mitarbeiter der Kanzlei diesen Browser-Tab live sieht und die Seite für mich bedienen kann (klicken, scrollen, Felder ausfüllen). Passwörter, Bank- und Steuerdaten werden geschwärzt. Ich kann die Sitzung jederzeit beenden.';

const SENSIBEL = /pass|kennwort|iban|bic|steuer|tax|ust|card|karte|cvc|cvv|pin|totp|2fa|otp/i;
export const istSensibel = (el) => !!el && (el.type === 'password' || el.closest?.('[data-cobrowse-mask]')
  || SENSIBEL.test([el.name, el.id, el.autocomplete, el.placeholder, el.getAttribute?.('data-testid')].filter(Boolean).join(' ')));

export const aufnahmeStarten = (emit) => record({
  emit,
  blockClass: 'rr-block',
  blockSelector: '[data-cobrowse-block]',
  maskTextSelector: '[data-cobrowse-mask]',
  maskInputOptions: { password: true, text: true, email: true, tel: true, number: true, search: true, textarea: true },
  maskInputFn: (text, el) => (istSensibel(el) ? '•'.repeat(Math.min(text.length, 12)) : text),
  sampling: { mousemove: 60, scroll: 120, input: 'last' },
  recordCanvas: false,
  collectFonts: false,
  inlineImages: false,
});

const knoten = (id) => record.mirror.getNode(id);
const gesperrt = (el) => !el || el.closest?.('.rr-block,[data-cobrowse-block]');

const setzeWert = (el, v) => {
  const proto = el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : el instanceof HTMLSelectElement ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
  Object.getOwnPropertyDescriptor(proto, 'value')?.set?.call(el, v);
  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
};

const klicken = (el) => {
  const r = el.getBoundingClientRect?.() || { left: 0, top: 0, width: 0, height: 0 };
  const o = { bubbles: true, cancelable: true, view: window, button: 0, clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 };
  el.dispatchEvent(new PointerEvent('pointerdown', { ...o, pointerType: 'mouse', isPrimary: true }));
  el.dispatchEvent(new MouseEvent('mousedown', o));
  el.focus?.({ preventScroll: true });
  el.dispatchEvent(new PointerEvent('pointerup', { ...o, pointerType: 'mouse', isPrimary: true }));
  el.dispatchEvent(new MouseEvent('mouseup', o));
  el.dispatchEvent(new MouseEvent('click', o));
};

// Stelle beim Mandanten 4 s hervorheben (Alt + Klick in der Kanzlei-Ansicht)
const markieren = (el, x, y, text) => {
  const dauer = text ? 8000 : 4000;
  const r0 = el?.getBoundingClientRect?.();
  if (r0 && (r0.top < 0 || r0.bottom > window.innerHeight || r0.left < 0 || r0.right > window.innerWidth)) el.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
  setTimeout(() => {
    const r = el?.getBoundingClientRect?.();
    const box = document.createElement('div');
    box.className = 'rr-block cb-marke';
    box.setAttribute('data-testid', 'cobrowse-markierung');
    if (r && r.width && r.height) Object.assign(box.style, { left: `${r.left - 6}px`, top: `${r.top - 6}px`, width: `${r.width + 12}px`, height: `${r.height + 12}px` });
    else Object.assign(box.style, { left: `${x - 24}px`, top: `${y - 24}px`, width: '48px', height: '48px', borderRadius: '50%' });
    const ring = document.createElement('span');
    ring.className = 'cb-marke-ring';
    box.appendChild(ring);
    if (text) {
      const notiz = document.createElement('button');
      notiz.type = 'button';
      notiz.className = 'cb-marke-notiz';
      notiz.setAttribute('data-testid', 'cobrowse-markierung-notiz');
      notiz.title = 'Schließen';
      notiz.textContent = text;
      const x2 = document.createElement('span');
      x2.className = 'cb-marke-x'; x2.textContent = '×';
      notiz.appendChild(x2);
      notiz.addEventListener('click', () => box.remove());
      if ((r?.bottom || y) + 56 > window.innerHeight) notiz.classList.add('cb-oben');
      box.appendChild(notiz);
    }
    document.body.appendChild(box);
    setTimeout(() => box.classList.add('cb-marke-aus'), dauer - 500);
    setTimeout(() => box.remove(), dauer);
  }, r0 && (r0.top < 0 || r0.bottom > window.innerHeight) ? 450 : 0);
};

// Fernsteuerung durch die Kanzlei ausführen
export const befehlAusfuehren = (m, setMaus) => {
  if (m.c === 'maus') { setMaus({ x: m.x, y: m.y }); return; }
  const el = knoten(m.id);
  if (m.c === 'scroll') {
    if (el && el.nodeType === Node.DOCUMENT_NODE) window.scrollTo(m.x, m.y);
    else if (el && !gesperrt(el)) el.scrollTo(m.x, m.y);
    return;
  }
  if (m.c === 'markieren') { markieren(el && !gesperrt(el) ? el : null, m.x, m.y, typeof m.text === 'string' ? m.text.slice(0, 80) : ''); return; }
  if (gesperrt(el)) return;
  if (m.c === 'click') klicken(el);
  else if (m.c === 'input' && 'value' in el) setzeWert(el, m.v);
  else if (m.c === 'key') {
    const ziel = el.nodeType === Node.ELEMENT_NODE ? el : document.activeElement || document.body;
    const ok = ziel.dispatchEvent(new KeyboardEvent('keydown', { key: m.k, bubbles: true, cancelable: true }));
    if (ok && m.k === 'Enter' && ziel.form && ziel.tagName !== 'TEXTAREA') ziel.form.requestSubmit?.();
    ziel.dispatchEvent(new KeyboardEvent('keyup', { key: m.k, bubbles: true }));
  }
};

// Verbindungsqualität: Laufzeit Hin und zurück über den Relay (beide Uhren lokal)
export const stufeFuer = (ms, stumm) => (stumm ? 'langsam' : ms == null ? null : ms < 300 ? 'gut' : ms <= 800 ? 'mittel' : 'langsam');
export const LANGSAM_TEXT = 'Langsame Verbindung, Aktionen kommen verzögert an';
export const createLatenz = (send, onUpdate) => {
  let ms = null; let letzte = Date.now();
  const melden = (stumm) => onUpdate({ ms, stufe: stufeFuer(ms, stumm), stumm });
  return {
    tick: () => { send({ t: 'lping', ts: Date.now() }); melden(Date.now() - letzte > 10000); },
    handle: (m) => {
      if (m.t === 'lping') { send({ t: 'lpong', ts: m.ts }); return true; }
      if (m.t !== 'lpong') return false;
      const neu = Date.now() - m.ts;
      ms = ms == null ? neu : Math.round(ms * 0.6 + neu * 0.4);
      letzte = Date.now(); melden(false);
      return true;
    },
    reset: () => { ms = null; letzte = Date.now(); onUpdate({ ms: null, stufe: null, stumm: false }); },
  };
};
